import React from 'react';

import classNames from 'classnames';

import { forTemplate } from 'common/lib/util/i18n';
const l = forTemplate('home');

import styles from './feature-feedback-link.less';

interface FeatureFeedbackLinkProps {
  feedbackLinkTranslationKey?: string;
  feedbackLinkUrl: string;
  feedbackTextTranslationKey?: string;
  onFeedbackLinkClick?: () => void;
  onDismissIconClick?: () => void;
}

export const FeatureFeedbackLink: React.FunctionComponent<
  FeatureFeedbackLinkProps
> = ({
  feedbackLinkTranslationKey,
  feedbackLinkUrl,
  feedbackTextTranslationKey,
  onFeedbackLinkClick = () => {},
  onDismissIconClick,
}) => (
  <div className={styles.feedbackContainer}>
    <span>
      <span>{l(feedbackLinkTranslationKey || 'feature-feedback-info')} </span>
      <a
        className={styles.feedbackLink}
        href={feedbackLinkUrl}
        onClick={onFeedbackLinkClick}
        rel="noopener noreferrer"
        target="_blank"
      >
        {l(feedbackTextTranslationKey || 'feature-feedback-link-text')}
      </a>
    </span>
    <button className={styles.dismissButtonIcon} onClick={onDismissIconClick}>
      <span className={classNames('icon-sm', 'icon-close')} />
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/feature-feedback-link.tsx